export const websocketConstants = {
  SET_USE_WEB_SOCKET: 'SET_USE_WEB_SOCKET',
  WS_CONNECTED: 'WS_CONNECTED',
  WS_DISCONNECTED: 'WS_DISCONNECTED',
  WS_CONNECT: 'WS_CONNECT',
  WS_DISCONNECT: 'WS_DISCONNECT',
  WS_CONNECT_ERROR: 'WS_CONNECT_ERROR',
  WS_EMIT: 'WS_EMIT',
  WS_EVENT: 'WS_EVENT',
  UPDATE_ALL_INBOXES_STATUS_LATEST_RECEIVED_TIME_WITH_DATA:
    'UPDATE_ALL_INBOXES_STATUS_LATEST_RECEIVED_TIME_WITH_DATA',
  UPDATE_ALL_INBOXES_STATUS_LATEST_RECEIVED_TIME:
    'UPDATE_ALL_INBOXES_STATUS_LATEST_RECEIVED_TIME',
};
